import React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import Webcam from "react-webcam";

// Reusable Image Upload and Capture Box
const ImageUploadBoxMultiple = ({
  index,
  imageSrc,
  openIndexes,
  webcamRef,
  fileInputRef,
  handleButtonClick,
  handleFileChange,
  capture,
  setOpenIndexes,
}) => {
  return (
    <Grid item xs={6} key={index} sx={{ textAlign: "center" }}>
      <Box
        className='upload-box'
        sx={{
          backgroundColor: "#E1F5FE",
          height: "auto",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant='h6' sx={{ color: "#FF5722", fontWeight: "bold" }}>
          Draw
        </Typography>
        <Grid container spacing={2} mt={1} ml={6} mb={2}>
          <Grid item>
            <Button
              variant='contained'
              onClick={() => {
                handleButtonClick(index);
                setOpenIndexes((prev) => prev.filter((i) => i !== index)); // Close webcam if opened
              }}
            >
              Upload
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant='contained'
              onClick={() => {
                setOpenIndexes((prev) => [...prev, index]); // Open webcam for this index
                capture(index);
              }}
            >
              Capture
            </Button>
          </Grid>
        </Grid>

        {/* Hidden file input element */}
        <input
          ref={(el) => (fileInputRef.current[index] = el)} // Assign ref to each file input
          type='file'
          accept='image/*'
          style={{ display: "none" }}
          onChange={(e) => handleFileChange(e, index)}
        />

        {/* Webcam Component */}
        {openIndexes.includes(index) && (
          <Webcam
            audio={false}
            ref={(el) => (webcamRef.current[index] = el)} // Assign ref to each webcam
            screenshotFormat='image/jpeg'
            style={{ width: "100%", height: "auto", marginTop: "10px" }}
          />
        )}

        {/* Show the image within this specific box */}
        {imageSrc && (
          <Box mt={2}>
            <img src={imageSrc} alt={`Captured or Uploaded ${index}`} style={{ maxWidth: "100%", height: "auto" }} />
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default ImageUploadBoxMultiple;
